module.exports = __webpack_public_path__ + "img/rightBottom7.d21d6f8.svg";